export default {
	baseUrl: 'http://zombie.afisha.ru'
}



// WEBPACK FOOTER //
// ./src/config.js